import { SoeknadStatusWeb } from '../../generated-types';

export const PAGE_ROOT = '/*';
export const PAGE_BOLIGVERDI_URL = '/boligverdi';
export const PAGE_BOLIGSALG_URL = '/boligsalg';
export const PAGE_LAANEBELOP_URL = '/laanebeloep';
export const PAGE_KONTAKTINFORMASJON_URL = '/kontaktinformasjon';
export const PAGE_SAMTYKKE_URL = '/samtykke';
export const PAGE_INNTEKT_URL = '/inntekt';
export const PAGE_LEIEINNTEKT_URL = '/leieinntekt';
export const PAGE_BILER_URL = '/biler';
export const PAGE_BARN_URL = '/barn';
export const PAGE_EGENKAPITAL_URL = '/egenkapital';
export const PAGE_GJELD_URL = '/gjeld';
export const PAGE_VEDLEGG_URL = '/vedlegg';
export const PAGE_OPPSUMMERING_URL = '/oppsummering';
export const PAGE_KVITTERING_URL = '/kvittering';
export const PAGE_GEOLOKASJON_URL = '/geolokasjon';

export const PageUrl = (status: SoeknadStatusWeb): string => {
    switch (status) {
        case SoeknadStatusWeb.NY_SOEKNAD:
            return PAGE_ROOT;
        case SoeknadStatusWeb.STEG_EIENDOMSVERDI:
            return PAGE_BOLIGVERDI_URL;
        case SoeknadStatusWeb.STEG_SALG_BOLIG:
            return PAGE_BOLIGSALG_URL;
        case SoeknadStatusWeb.STEG_LAANEBELOEP:
            return PAGE_LAANEBELOP_URL;
        case SoeknadStatusWeb.STEG_KONTAKTINFORMASJON:
            return PAGE_KONTAKTINFORMASJON_URL;
        case SoeknadStatusWeb.STEG_SAMTYKKER:
            return PAGE_SAMTYKKE_URL;
        case SoeknadStatusWeb.STEG_INNTEKT:
            return PAGE_INNTEKT_URL;
        case SoeknadStatusWeb.STEG_LEIEINNTEKTER:
            return PAGE_LEIEINNTEKT_URL;
        case SoeknadStatusWeb.STEG_BILER:
            return PAGE_BILER_URL;
        case SoeknadStatusWeb.STEG_BARN:
            return PAGE_BARN_URL;
        case SoeknadStatusWeb.STEG_EGENKAPITAL:
            return PAGE_EGENKAPITAL_URL;
        case SoeknadStatusWeb.STEG_GJELD:
            return PAGE_GJELD_URL;
        case SoeknadStatusWeb.STEG_VEDLEGG:
            return PAGE_VEDLEGG_URL;
        case SoeknadStatusWeb.STEG_OPPSUMMERING:
            return PAGE_OPPSUMMERING_URL;
        case SoeknadStatusWeb.STEG_MEDLAANTAKER_INNTEKT:
            return PAGE_INNTEKT_URL;
        case SoeknadStatusWeb.STEG_MEDLAANTAKER_BARN:
            return PAGE_BARN_URL;
        case SoeknadStatusWeb.STEG_MEDLAANTAKER_EGENKAPITAL:
            return PAGE_EGENKAPITAL_URL;
        case SoeknadStatusWeb.STEG_MEDLAANTAKER_GJELD:
            return PAGE_GJELD_URL;
        case SoeknadStatusWeb.STEG_MEDLAANTAKER_VEDLEGG:
            return PAGE_VEDLEGG_URL;
        case SoeknadStatusWeb.STEG_MEDLAANTAKER_OPPSUMMERING:
            return PAGE_OPPSUMMERING_URL;
        default:
            return PAGE_ROOT;
    }
};
